import { render } from "./HeroiconsOutlineViewBoards.vue?vue&type=template&id=0947c624"
const script = {}

import exportComponent from "/home/tobias/Desktop/screenads/nova-custom2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineViewBoards.vue"]])

export default __exports__